import { h, render } from 'preact';

const className = (...names) => names.filter(name => !!name).join(' ');

const Gallery = ({ image, requestPrev, requestNext, requestClose, visible }) => (
  <div className={className('gallery', visible && 'gallery--visible')}>
	<div className="gallery__image">
	  <img className="img" src={image.src} alt={image.alt} title={image.title} />
	</div>
	<div className="gallery__prev" onClick={requestPrev}>
	  <i className="fa fa-chevron-left fa-3x"/>
	</div>
	<div className="gallery__next" onClick={requestNext}>
	  <i className="fa fa-chevron-right fa-3x"/>
	</div>
	<div className="gallery__close" onClick={requestClose}>
	  <i className="fa fa-close fa-3x"/>
	</div>
  </div>
);

export default $el => {
	const $button = $el.querySelector('.js-trigger');
	const images = JSON.parse($el.querySelector('[data-images]').innerHTML);

	const $wrapper = document.createElement('div');
	$wrapper.classList.add('galleryWrapper');
	document.body.appendChild($wrapper);

	let root;
	let activeImage = images[0];

	const renderComponent = (visible = false) => {
		root = render(
			<Gallery
				image={activeImage}
				visible={visible}
				requestPrev={() => renderPrev(images, activeImage)}
				requestNext={() => renderNext(images, activeImage)}
				requestClose={() => renderComponent(false)}
			/>,
			$wrapper,
			root
		);

		document.body.classList[visible ? 'add' : 'remove']('body--noScroll');
	};

	$button.addEventListener('click', e => {
		e.preventDefault();
		renderComponent(true);
	}, false);

	const renderPrev = (images, image) => {
		activeImage = images.indexOf(image) <= 0 ? images[images.length - 1] : images[images.indexOf(image) - 1];
		renderComponent(true);
	};

	const renderNext = (images, image) => {
		activeImage = ((images.indexOf(image) + 1) >= (images.length)) ? images[0] : images[images.indexOf(image) + 1];
		renderComponent(true);
	};
}
